import _Vue from 'vue'
import store from '@/store'
import { TranslateResult } from 'vue-i18n'

interface AlertPayload {
  title?: string | TranslateResult
  content?: string | TranslateResult
  color?: string
}

export default {
  install: (Vue: typeof _Vue) => {
    Vue.prototype.$alert = async (payload: AlertPayload) => {
      return await store.dispatch('alert/alert', payload)
    }
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $alert: (payload: AlertPayload) => Promise<boolean>
  }
}
